import EventEmitter from "eventemitter3";
export class Eventsource {
    constructor(initState) {
        this.eventEmitter = new EventEmitter();
        this.eventName = "event";
        this.latestState = initState();
    }
    get state() {
        return this.latestState;
    }
    on(listener, context) {
        this.eventEmitter.on(this.eventName, listener, context);
    }
    off(listener, context) {
        this.eventEmitter.off(this.eventName, listener, context);
    }
    offAll() {
        this.eventEmitter.removeAllListeners(this.eventName);
    }
    emit(value) {
        this.latestState = value;
        const that = this;
        setTimeout(() => {
            that.eventEmitter.emit(that.eventName, value);
        });
    }
    listen(listener) {
        this.on(listener);
        const that = this;
        return {
            cancel() {
                that.off(listener);
            },
        };
    }
}
